module.exports = __webpack_public_path__ + "img/leiterinnen_andrea-ruh.0f0dc48b.png";